import React from 'react';
import { Link } from 'react-router-dom';

const rows = [
  [
    "Coppini membership (required to apply)",
    <>
      $60/year annual, or $500 lifetime &mdash; see{' '}
      <Link to="/membership" className="font-semibold text-[#7c2434] underline hover:text-[#17243d]" data-testid="gallery-fee-membership-link">
        current membership rates
      </Link>
      .
    </>,
  ],
  ["Ongoing rotation application", "Free to apply. No application payment is required for a new application."],
  ["Coppini commission on sales", "25% Coppini, 75% artist, on sales of original art."],
  ["Cooperative service", "One six-hour shift per month. Members unable to commit may choose three $50 monthly payments ($150 total) or one $150 payment for staffing coverage."],
  ["Monthly wall rent", "$0."],
];

export const GalleryFeeSchedule = ({ applicationsOpen = false, availabilityKnown = true }) => (
  <section className="border-y border-[#c8cbd1] bg-[#f4f5f7]" data-testid="gallery-fee-schedule-section">
    <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-24">
      <p className="text-xs font-semibold uppercase text-[#7c2434]">Fees &amp; membership</p>
      <h2 className="mt-3 font-gallery-heading text-3xl text-[#17243d]">What it costs to participate</h2>
      <p className="mt-4 max-w-2xl text-sm leading-6 text-[#5d6470]" data-testid="gallery-fee-schedule-note">
        {!availabilityKnown ? 'The fees below explain participation costs. Check current application availability at the top of this page.' : applicationsOpen ? 'New applications are free. There is no staffing charge for members who commit to the monthly shift. Existing payment records and receipts are preserved.' : 'Gallery applications and new gallery fee payments are currently unavailable. Membership purchases remain available on the membership page.'}
      </p>

      <div className="mt-10 divide-y divide-[#c8cbd1] border border-[#c8cbd1] bg-white" data-testid="gallery-fee-schedule-table">
        {rows.map(([term, description]) => (
          <div
            key={term}
            className="flex flex-col gap-2 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:gap-8 md:px-8"
            data-testid={`gallery-fee-row-${term.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          >
            <p className="font-gallery-display text-base text-[#17243d]">{term}</p>
            <p className="text-sm leading-6 text-[#5d6470] sm:max-w-sm sm:text-right">{description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
